/* src/app/shared/layout/ag-tree/ag-tree-leaf/ag-tree-leaf.component.scss */
.ag-tree-leaf {
  border-top: 1px solid #f1f1f1;
  min-height: 70px;
}
.agDescription {
  font-size: 13px;
}
/*# sourceMappingURL=ag-tree-leaf.component.css.map */
